export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7935.5421f152.jpg";